<template>
  <div class="que-box" :style="{'display': display}">
    <div class="que-title">
      <span @click="openQue">{{fque_name}}</span>
      <span @click="openUsecase" style="color: red; margin-left: 5px;">{{fdifficulty}}</span>
    </div>
    <div style="margin: 5px 10px;" id="question-id"
         class="markdown-body"
         v-html="fque_context" >
    </div>
    <usercaseDialog
        :dialog-state="usercaseDialogState"
        @event-dialog-close="usecaseDialogClose"></usercaseDialog>

    <queDialog
        :dialog-state="queDialogState"
        @event-dialog-close="queDialogClose"></queDialog>
  </div>
</template>

<script>
import usercaseDialog from "@/components/panel/usercaseDialog";
import queDialog from "@/components/panel/queDialog";
import serviceApi from "@/utils/serviceApi";
import cookies from 'vue-cookies';
import {marked} from 'marked'
import 'mavon-editor/dist/css/index.css'
import globalVariable from "@/config/globalVariable";

export default {
  name: "quePage",
  data(){
    return{
      usercaseDialogState: false,
      queDialogState: false,
      queInfo:{
          gid:'',
          que_name:'',
          que_tags:'',
          que_context:'',
          difficulty: 20,
          contain_answer:'',
          cate:''
      }
    }
  },
  props:{
    isShow: Boolean
  },
  watch:{
    "isShow":{
      handler(newVal, oldVal) {
        if(newVal && !oldVal){
          serviceApi.loadQue(this.callback);
        }
      },
      deep: false,
      immediate: true
    }
  },
  computed:{
    display:function (){
      if(this.isShow){
        return "block"
      }else{
        return "none";
      }
    },
    fque_name:function (){
      return '[' + this.queInfo.que_name + ']'
    },
    fdifficulty: function (){
      let result = '★';
      for(let i = 0; i < this.queInfo.difficulty / 10; i ++){
        result = result + '★'
      }
      return result;
    },

    fque_context:function (){
      //return decodeURI(this.queInfo.que_context)
      return this.marked(this.queInfo.que_context)
    }
  },
  mounted() {
    //serviceApi.loadQue(this.callback);
    setTimeout(()=>{
      this.$nextTick(this.contextClick)
    }, 1000)
  },
  methods:{
    contextClick: function (){
        if(globalVariable.isMathjaxConfig){//判断是否初始配置，若无则配置。
              globalVariable.initMathjaxConfig();
          }
          globalVariable.MathQueue("question-id");//传入组件id，让组件被MathJax渲染
    },

    marked: function (val){
      if (val == null || val == undefined){
        return '';
      }else{
        return marked(val);
      }
    },
    callback:function (resultData){
      this.queInfo = resultData;
      if(this.queInfo.cate == "db"){
        this.queInfo.que_context = decodeURIComponent(this.queInfo.que_context);
      }
      this.$emit('event-que', resultData.que_name);
    },
    openUsecase: function (){

      if (cookies.get('guid') != null && cookies.get('guid') == "0849c42f236f7cb046a06d41832f1723"){
        this.usercaseDialogState = true;
      }
    },
    usecaseDialogClose: function (){
      this.usercaseDialogState = false;
    },
    openQue: function (){
      if (cookies.get('guid') != null && cookies.get('guid') == "0849c42f236f7cb046a06d41832f1723"){
        this.queDialogState = true;
      }
    },
    queDialogClose: function (){
      this.queDialogState = false;
    }
  },
  components:{
    usercaseDialog,
    queDialog
  }

}
</script>

<style scoped>
.que-box{
  width: calc(100% - 1px);
  height:calc(100% - 1px);
  background-color: #fff;
  color: #0a001f;
  overflow-y:auto;
}
.que-title{
  padding: 3px 10px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
}
.que-pre{
  background-color: #fff;
  color: #0a001f;
  white-space: pre-wrap;
  word-wrap: break-word;
  font-size: 14px;
}
</style>

